module.exports = __webpack_public_path__ + "img/zimm-standing.97d97b14.png";